export default __webpack_public_path__ + "static/media/login.105a21f9.svg";